import { render } from "./slide8.vue?vue&type=template&id=4623e9a8&scoped=true"
import script from "./slide8.vue?vue&type=script&lang=js"
export * from "./slide8.vue?vue&type=script&lang=js"

import "./slide8.vue?vue&type=style&index=0&id=4623e9a8&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4623e9a8"]])

export default __exports__